// extracted by mini-css-extract-plugin
module.exports = {"skillCard":"Card_skill-card__3O8BY","title":"Card_title__1uCGi"};